exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section-heading{margin-top:15px;margin-bottom:15px;padding-top:10px;padding-bottom:10px;font-size:1.25rem;line-height:1.563rem;letter-spacing:-.0625rem;font-weight:400}@media (min-width:768px){.section-heading{font-size:1.75rem;line-height:1.875rem;letter-spacing:-.125rem}}@media (min-width:1200px){.section-heading{font-size:2rem;line-height:2.5rem;letter-spacing:-.125rem}}.heading-number{display:inline-block;width:30px;height:30px;padding:3px 9px 6px 8px;margin-right:15px;border-radius:50%;text-align:center;font-size:1.125rem;font-weight:700}@media (min-width:768px){.heading-number{width:34px;height:34px;padding-top:2px;font-size:1.25rem}}@media (min-width:1200px){.heading-number{width:42px;height:42px;padding-top:0;font-size:1.75rem}}.heading-title{vertical-align:middle;display:inline-block;font-weight:700;width:80%}.heading-description{font-weight:500;line-height:1.2em;color:#545454}.heading-description a{text-decoration:underline}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/SectionHeading/SectionHeading.scss
 ** module id = 1216
 ** module chunks = 0
 **/